/**
 * Console log a message in case app is in development mode
 *
 * @param {string} message
 * @returns {void}
 * @package stylr
 */
export default function devlog( ...message ) {
    if ( window.app && window.app.mode && 'development' === window.app.mode ) {
        console.log( ...message );
    }
}
